import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.status)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["overlay", { closing: _ctx.closing }]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeAway && _ctx.closeAway(...args)), ["self"]))
      }, [
        _createElementVNode("div", {
          class: "modal-wrapper",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeAway && _ctx.closeAway(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "content", {}, undefined, true)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}